import { useAuth } from '@/context/AuthContext';

const VAT_RATE = 0.25;

/**
 * Hook som returnerar prisformattering baserat på kontotyp.
 * Privatpersoner ser priser inkl. moms, företag exkl. moms.
 */
export const usePricing = () => {
  const { user } = useAuth();
  const isBusiness = user?.account_type === 'business';

  /** Returnera visningspris (exkl. moms för företag) */
  const displayPrice = (priceInclVat) => {
    if (!priceInclVat && priceInclVat !== 0) return 0;
    if (isBusiness) return Math.round((priceInclVat / (1 + VAT_RATE)) * 100) / 100;
    return priceInclVat;
  };

  /** Formatera pris som "1 234 kr" */
  const formatPrice = (priceInclVat) => {
    const p = displayPrice(priceInclVat);
    return p.toLocaleString('sv-SE') + ' kr';
  };

  /** Moms-belopp */
  const vatAmount = (priceInclVat) => {
    if (!priceInclVat) return 0;
    return Math.round((priceInclVat * VAT_RATE / (1 + VAT_RATE)) * 100) / 100;
  };

  /** Pris exkl. moms */
  const priceExclVat = (priceInclVat) => {
    if (!priceInclVat) return 0;
    return Math.round((priceInclVat / (1 + VAT_RATE)) * 100) / 100;
  };

  /** Prisetikett ("inkl. moms" eller "exkl. moms") */
  const vatLabel = isBusiness ? 'exkl. moms' : 'inkl. moms';

  return {
    isBusiness,
    displayPrice,
    formatPrice,
    vatAmount,
    priceExclVat,
    vatLabel,
    vatRate: VAT_RATE,
  };
};
